import { IconNames } from "@blueprintjs/icons";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Menu from "../app/SideDrawer/Menu";
import AppModuleConnector from "../utils/AppFramework/AppModuleConnector";
import Activities from '../torga/Activity/Activities';
import Routine from '../torga/Routine/Routines';
import { TorgaContext, TorgaContextProvider } from './TorgaContext';
import Goals from '../torga/Goal/Goals';
import Tasks from '../torga/Task/Tasks';
import { search } from './search';

class TorgaObject {
  constructor(key, name, singular) {
    this.key = key;
    this.name = name;
    this.singular = singular;
    this.domain = 's';
    this.usePrefix = false;
  }

  get uri() {
    return `/${this.domain}/${this.singular}`;
  }

  objectUri(id) {
    const prefix = this.usePrefix ? this.key : '';
    return `/${this.domain}/${this.singular}/${prefix}${id}`;
  }

  withPrefixURI() {
    this.usePrefix = true;
    return this;
  }
}

export const ObjectTypes = {
  ACTIVITIES: new TorgaObject('A', 'activities', 'activity').withPrefixURI(),
  EQUIPMENTS: new TorgaObject('E', 'equipments'),
  TRIPS: new TorgaObject('V', 'trips'),
  DIARYPOSTS: new TorgaObject('D', 'diaryposts'),
  ROUTINE: new TorgaObject('R', 'routines'),
  GOALS: new TorgaObject('G', 'goals'),
  TASKS: new TorgaObject('T', 'tasks'),
};

export const urlToActivity = () => ObjectTypes.ACTIVITY.uri;
export const urlToActivityID = (id) => {
  const isReview =
    window.location.pathname.slice(0, urlToReview().length) === urlToReview();
  return `/t/${isReview ? 'review' : 'activity'}/A${id}`;
};
export const urlToEquipmentID = (id) => `/t/equipment/${id}`;
export const urlToEquipment = () => `/t/equipment`;
export const urlToReview = () => `/t/review`;
export const urlToCalendar = () => `/t/calendar`;
export const urlToTripID = (id) => `/t/trip/${id}`;
export const urlToDiary = () => `s/diary`;
export const urlToDiaryPost = (id) => `/t/diary/${id}`;
export const urlToReviewID = (id) => `/t/review/A${id}`;
export const urlToRoutineID = (id) => `/t/routine/R${id}`;
export const urlToGoal = () => `/t/goal`;
export const urlToGoalID = (id) => `/t/goal/G${id}`;
export const urlToTask = () => `/t/task`;
export const urlToTaskID = (id) => `/t/task/T${id}`;

const MENU_ENTRIES = [
  { name: 'Activities', path: `/t/activity`, icon: IconNames.PULSE },
  {
    name: 'Review',
    path: `/t/review`,
    icon: IconNames.TICK_CIRCLE,
    badge: 'TORGA_REVIEW',
  },
  { name: 'Routine', path: `/t/routine`, icon: IconNames.REPEAT },
  { name: 'Goals', path: `/t/goal`, icon: IconNames.TARGET },
  { name: 'Tasks', path: `/t/task`, icon: IconNames.TICK },
];

export default function Torga() {
  return (
    <TorgaContextProvider>
      <Menu name="Torga" entries={MENU_ENTRIES} />
      <AppModuleConnector
        context={TorgaContext}
        name="Torga"
        objectTypes={ObjectTypes}
        search={search}
      />

      <Routes>
        <Route path="/t/activity/:id?" element={<Activities />} />
        <Route path="/t/routine/:id?" element={<Routine />} />
        <Route path="/t/goal/:id?" element={<Goals />} />
        <Route path="/t/task/:id?" element={<Tasks />} />
      </Routes>
    </TorgaContextProvider>
  );
}
